import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {
  Box,
  Typography as Typo,
  styled,
  TypographyProps,
  Card,
} from '@mui/material';

const StyledCard = styled(Card)({
  height: 'auto',
  overflow: 'visible',
});

const Typography = styled(Typo)<TypographyProps>(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

type NavigationPanelProps = {
  title: string | JSX.Element;
  menu: Array<{label: string; key: string | number}>;
  selectedItem?: string | number | undefined;
  onSelect: (item: string | number) => void;
};

const NavigationComponentHirist = ({
  title,
  menu,
  selectedItem,
  onSelect,
}: NavigationPanelProps) => {
  const theme = useWrappedTheme();
  const Header = () => (typeof title !== 'string' ? title : <></>);
  return (
    <>
      <Box
        sx={{
          px: 0,
          py: 0,
          width: {md: 226},
          height: 'fit-content',
        }}
      >
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          rowGap={0}
        >
          {menu.map(item => (
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}
              onClick={() => onSelect(item.key)}
              sx={{
                backgroundColor:
                  selectedItem === item.key ? '#fff' : 'transparent',
                color:
                  selectedItem === item.key
                    ? theme.palette.primary.main
                    : '#212529',
                borderTopLeftRadius: selectedItem === item.key ? '8px' : '0px',
                borderBottomLeftRadius:
                  selectedItem === item.key ? '8px' : '0px',
                padding: '18px 0px 18px 17px',
                cursor: 'pointer',
              }}
            >
              <Typography
                variant="subtitle2"
                fontSize={{xxs: 16, md: 16}}
                fontWeight={500}
              >
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default NavigationComponentHirist;
